import {useContext} from "react";
import {ConfigContext, ConfigContextValue} from "./ConfigProvider";

export function useConfig(): ConfigContextValue {
    return useContext<ConfigContextValue>(ConfigContext);
}
